export const configOptions = {
  showOffers: true,
  showProductImage: true,
  showFoodCat: true,
  showSponsor: true,
  showSlot: true,
  showBrand: true,
  showProductName: true,
  showRatings: true,
  showCosmetics: true,
  showPacksize: true,
  showSp: true,
  showMrp: true,
  showBBstar: true,
  showCta: true,
  showSFLbutton: true,
  showAddButton: true,
  showQuantityChanger: true,
  showThreeDots: false,
  showRemoveItem: true,
  showTitle: true,
  showPdLinkableThreedots: true,
  renderTagsAndSlot: true,
  renderRnR: true,
  renderBBStar: true,
  renderOfferComm: true,
  renderSKUImage: true,
  renderPackSelector: true,
};

export const OfcEntryPoint = {
  renderPackSelector: false,
  showOffers: false,
  renderSKUImage: false,
  showProductImage: false,
  showFoodCat: false,
  showSponsor: false,
  showSlot: false,
  showBrand: true,
  showProductName: true,
  showRatings: false,
  showCosmetics: false,
  showPacksize: false,
  showSp: true,
  showMrp: true,
  showBBstar: false,
  showCta: false,
  showSFLbutton: true,
  showAddButton: true,
  showQuantityChanger: true,
  showThreeDots: false,
  showRemoveItem: false,
  showTitle: false,
  showPdLinkableThreedots: false,
  renderTagsAndSlot: false,
  renderRnR: false,
  renderBBStar: false,
  renderOfferComm: false,
};

const sfl = {
  ...configOptions,
  showSFLbutton: false,
  renderRnR: false,
  showSlot: true,
  showBBstar: false,
  showPdLinkableThreedots: false,
  showThreeDots: true,
  showSponsor: false,
  renderBBStar: false,
  renderTagsAndSlot: true,
  renderOfferComm: false,
};

const fbt = {
  ...configOptions,
  showSlot: true,
  showRemoveItem: false,
  showBBstar: false,
  renderOfferComm: false,
  showSponsor: true,
};

const ms = {
  ...configOptions,
  showSlot: true,
  renderTagsAndSlot: true,
  renderRnR: false,
  showRemoveItem: false,
  showTabs: true,
  renderBBStar: false,
  showTitle: false,
  showBBstar: false,
  showSponsor: false,
  renderOfferComm: false,
};

const sml = {
  ...configOptions,
  showSlot: true,
  showRemoveItem: false,
  showBBstar: false,
  renderOfferComm: false,
  showSponsor: false,
};
const pcSpotlight = {
  ...configOptions,
  showSlot: false,
  showRemoveItem: false,
  showBBstar: false,
  showSponsor: false,
};

const dyf = {
  ...configOptions,
  showSlot: true,
  renderRnR: false,
  renderBBStar: false,
  showRemoveItem: false,
  showBBstar: false,
  showSponsor: false,
  renderTagsAndSlot: true,
  renderOfferComm: false,
};

const listing = {
  ...configOptions,
  showRemoveItem: false,
  showPdLinkableThreedots: false,
};

const combo = {
  ...configOptions,
  showTitle: false,
  showBBstar: false,
  renderTagsAndSlot: false,
  renderRnR: false,
  renderBBStar: false,
  renderOfferComm: false,
};

const shopFromOrder = {
  ...listing,
  productSelection: true,
};

export const variations = { sfl, fbt, ms, sml, dyf, listing, combo, shopFromOrder, pcSpotlight };
